import { FC } from "react";

const TagIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  fill = "#1F2A37",
  width = "24",
  height = "24",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_3747_59494)">
      <path
        d="M18.9063 17.0189L6.98131 18.9089C3.69031 19.4279 0.597313 17.1839 0.0753134 13.8899C-0.446687 10.5959 1.80031 7.50294 5.09431 6.98094L17.0193 5.09094C20.3133 4.56894 23.4033 6.81594 23.9253 10.1099C24.4473 13.4039 22.1973 16.4969 18.9063 17.0189Z"
        fill="#FDC8D3"
      />
      <path
        d="M12.2644 22.7475C11.2954 22.7475 10.3924 22.3905 9.3394 21.5865C8.4184 20.8845 7.4164 19.8825 6.03041 18.4965L4.20041 16.6665C2.56541 15.0315 1.74641 14.2125 1.40441 13.0215C1.06241 11.8335 1.32341 10.7025 1.84541 8.44948L2.12741 7.22248C2.55941 5.35348 2.79641 4.32448 3.5614 3.55948C4.32641 2.79448 5.3554 2.55748 7.2244 2.12548L8.45141 1.84348C10.7044 1.32448 11.8354 1.06348 13.0234 1.40248C14.2114 1.74448 15.0334 2.56348 16.6684 4.19848L18.4984 6.02848C19.8844 7.41448 20.8864 8.41648 21.5884 9.33748C22.3924 10.3905 22.7494 11.2935 22.7494 12.2625C22.7494 13.2315 22.3924 14.1345 21.5884 15.1875C20.8864 16.1085 19.8844 17.1105 18.4984 18.4965C17.1124 19.8825 16.1104 20.8845 15.1894 21.5865C14.1364 22.3875 13.2334 22.7475 12.2644 22.7475ZM11.8924 2.74648C11.1784 2.74648 10.2484 2.96248 8.7874 3.29848L7.5604 3.58048C5.9104 3.96148 5.08241 4.15348 4.62041 4.61248C4.15841 5.07448 3.96941 5.90248 3.58841 7.55248L3.30641 8.77948C2.84141 10.7865 2.61041 11.7885 2.84441 12.6045C3.07841 13.4205 3.8074 14.1495 5.25941 15.6015L7.08941 17.4315C9.62741 19.9695 10.9024 21.2445 12.2644 21.2445C13.6264 21.2445 14.8984 19.9695 17.4394 17.4315C19.9774 14.8935 21.2524 13.6185 21.2524 12.2565C21.2524 10.8945 19.9774 9.62548 17.4364 7.08448L15.6064 5.25448C14.1544 3.80248 13.4254 3.07348 12.6094 2.83948C12.3904 2.77648 12.1564 2.74648 11.8924 2.74648Z"
        fill={fill}
      />
      <path
        d="M8.60737 11.621C7.87237 11.621 7.18238 11.336 6.66338 10.817C6.14438 10.298 5.85938 9.608 5.85938 8.873C5.85938 8.138 6.14438 7.448 6.66338 6.929C7.18238 6.41 7.87237 6.125 8.60737 6.125C9.34237 6.125 10.0324 6.41 10.5514 6.929C11.0704 7.448 11.3554 8.138 11.3554 8.873C11.3554 9.608 11.0704 10.298 10.5514 10.817C10.0324 11.333 9.34237 11.621 8.60737 11.621ZM8.60737 7.619C8.27437 7.619 7.95937 7.748 7.72237 7.985C7.48537 8.222 7.35637 8.534 7.35637 8.87C7.35637 9.203 7.48537 9.518 7.72237 9.755C7.95937 9.992 8.27137 10.121 8.60737 10.121C8.94037 10.121 9.25537 9.992 9.49237 9.755C9.72937 9.518 9.85838 9.206 9.85838 8.87C9.85838 8.537 9.72937 8.222 9.49237 7.985C9.25537 7.751 8.94337 7.619 8.60737 7.619ZM11.5444 19.241C11.3524 19.241 11.1604 19.169 11.0134 19.022C10.7194 18.728 10.7194 18.254 11.0134 17.96L17.9914 10.982C18.2854 10.688 18.7594 10.688 19.0534 10.982C19.3474 11.276 19.3474 11.75 19.0534 12.044L12.0724 19.022C11.9284 19.169 11.7364 19.241 11.5444 19.241Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_3747_59494">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TagIcon;
